export const SEND_SLACK = 'SEND_SLACK';
export const SLACK_SENT = 'SLACK_SENT';
export const SLACK_ERROR = 'SLACK_ERROR';